"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Caption = _styledComponents.default.caption.withConfig({
  displayName: "fluffy--Caption",
  componentId: "fluffy--1w8iwr2"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 8px;\n    font-size: 20px;\n    font-weight: 700;\n    white-space: pre-line;\n"], ["\n    margin: 8px;\n    font-size: 20px;\n    font-weight: 700;\n    white-space: pre-line;\n"])));
exports.Caption = Caption;
var templateObject_1;